import { useSystemColorScheme } from "@/hooks/useSystemColorScheme.ts";
import { useColorSchemeContext } from "@hopper-ui/styled-system";
import { useFeatureFlag } from "@workleap-ai/shared";
import { useEffect } from "react";

export const ColorSchemeUpdater = () => {
    const { hasFeatureFlag } = useFeatureFlag();
    const isDarkModeEnabled = hasFeatureFlag("HeroAppDarkMode");
    const systemColorScheme = useSystemColorScheme(isDarkModeEnabled);
    const { setColorScheme } = useColorSchemeContext();

    useEffect(() => {
        setColorScheme(systemColorScheme);
    }, [systemColorScheme, setColorScheme]);

    return null;
};
